export default "__VITE_ASSET__CmkClO$G__"